module.exports = __webpack_public_path__ + "img/clound_2.19d7d68f.png";